<template>
  <div class="thinking-container">
    <!-- <div class="thinking-text">AI 正在思考中...</div> -->
    <div class="pulse-dots">
      <div class="pulse-dot"></div>
      <div class="pulse-dot"></div>
      <div class="pulse-dot"></div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang='less' scoped>
.thinking-container {
  text-align: center;
}

.thinking-text {
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 15px;
}

.pulse-dots {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.pulse-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #4a90e2;
  animation: pulse 1.4s infinite ease-in-out both;
}

.pulse-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.pulse-dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes pulse {
  0%, 80%, 100% {
    transform: scale(0.4);
    opacity: 0.4;
  }
  40% {
    transform: scale(1.0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingDot.vue